import React from "react";
import { Link } from "react-router-dom";

export const transactionHistoryColumns = ({handleRenew, handleCancelled, PAGE_SIZE}) => [
   {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Member Id",
    render: (row) => 
       <Link >{row.user?.profile_id || "-"}</Link>    
  },
  {
    label: "Member Name",
    render: (row) => (
        <span>
            {row?.user?.name || "-"}
        </span>
    )
  },
  {
    label: "Transaction Date",
    render: (row) => (
      <div>
       {row?.createdAt
                ? new Date(row.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "-"}
      </div>
    ),
  },
  {
    label: "Amount",
    render: (row) => (
      <div>
      ₹{row?.price || "-"}
      </div>
    ),
  },
  {
  label: "Subscription Expiry Date.",
    width: 220,
    render: (row) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // remove time part

      const expiryDate = row?.expiry_date
        ? new Date(row.expiry_date)
        : null;

      if (expiryDate) {
        expiryDate.setHours(0, 0, 0, 0); // remove time part
      }

      return (
        <div>
          {expiryDate
            ? expiryDate.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "-"}

          <br />

          {row.status === "Paid" &&
            expiryDate &&
            expiryDate > today || row.status === "Paid" && row?.plan?.name === "VIP" && (
              <Link
                to="#"
                onClick={() => handleCancelled(row, "Cancelled")}
              >
                Cancel Membership
              </Link>
            )}
        </div>
      );
    },
  },
  {
    label: "Coupon Code",
    render: (row) => (
      <div>
     {row?.coupon_code || "-"}
      </div>
    ),
  },
  {
    label: "Status",
    render: (row) => (
      row?.status === "Paid" ? 
      <div style={{minWidth: "70px", display: "flex", color: "rgb(255, 255, 255)", padding: "5px 10px", justifyContent: "center", borderRadius: "10px", background: "rgb(72, 142, 72)"}}>Success</div> 
      : row?.status === "Failed" ?
      <div style={{minWidth: "70px", display: "flex", color: "rgb(255, 255, 255)", padding: "5px 10px", justifyContent: "center", borderRadius: "10px", background: "rgb(255, 0, 0)"}}>Failed</div>
      : row?.status === "Pending" ?
      <div style={{minWidth: "70px", display: "flex", color: "rgb(255, 255, 255)", padding: "5px 10px", justifyContent: "center", borderRadius: "10px", background: "rgb(255, 165, 0)"}}>Pending</div>
      : row?.status === "Refunded" ?
      <div style={{minWidth: "70px", display: "flex", color: "rgb(255, 255, 255)", padding: "5px 10px", justifyContent: "center", borderRadius: "10px", background: "rgb(181, 24, 24)"}}>Refunded</div>
      : row?.status === "Cancelled" ?
      <div style={{minWidth: "70px", display: "flex", color: "rgb(250, 246, 246)", padding: "5px 10px", justifyContent: "center", borderRadius: "10px", background: "rgb(179, 32, 32)"}}>Cancelled</div>
      : <div style={{minWidth: "70px", display: "flex", color: "rgb(255, 255, 255)", padding: "5px 10px", justifyContent: "center", borderRadius: "10px", background: "rgb(0, 0, 0)"}}>-----</div>
    ),
  },
  {
    label: "Action",
    render: (row) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const expiryDate = row?.expiry_date
        ? new Date(row.expiry_date)
        : null;

      if (expiryDate) {
        expiryDate.setHours(0, 0, 0, 0);
      }

      const isValid =
        expiryDate && expiryDate >= today;

      return (
        <>
          {isValid && row?.status === "Paid" || row.status === "Paid" && row?.plan?.name === "VIP"   ? (
            <Link
              to="#"
              onClick={() => handleCancelled(row, "Refunded")}
              className="sitebtn text-white text-center px-2 py-1 m-2 d-inline-block"
              style={{ textDecoration: "none" }}
            >
              Refund
            </Link>
          ) : (
            <span className="text-danger">----</span>
          )}
        </>
      );
    },
  }
];
